import createComponent, {
  ElementWithProps
} from '@carvana/merch-components/createComponent';
import cx from 'classnames';

export const contentWithNavStyles =
  'flex flex-col gap-2xl px-2xl py-4xl md:px-0 md:py-5xl';

export const TileGrid = createComponent<
  ElementWithProps & { withNav?: boolean }
>('div', ({ withNav = false }) => ({
  className: cx(
    'grid grid-cols-1 gap-md sm:grid-cols-2',
    withNav ? 'lg:grid-cols-3' : 'md:grid-cols-3'
  )
}));
